export default import.meta.ROLLDOWN_FILE_URL_Sw5QIwFIYi4x_gY32PsPXQ